<template>
  <div style="z-index: 3" :class="$vuetify.breakpoint.smAndDown ? 'home-detail-mobile' : 'home-detail'"
    >
    <v-btn style="cursor: pointer; position: absolute; z-index: 1; left: 50%; transform: translateX(-50%); top: 0px" icon @click="$router.push({name: 'Home'})">
      <v-icon large> keyboard_arrow_down </v-icon>
    </v-btn>
    <div v-if="show_sidebar && !hide_sidebar" :style="$vuetify.breakpoint.smAndDown ? 'min-width: 100%; max-width: 100%' : ''" class="home-detail-sidebar">
      <div  @click="$router.push({name: 'Home'})" class="home-detail-sidebar-header">
        <slot name="header-text"/>
      </div>
      <div class="home-detail-sidebar-navigation">
        <div style="width:100%; padding: 10px">
          <slot name="navigation"/>
        </div>
        <div style="width: 40px; height: 100%; border-left: solid 1px; display: flex; flex-direction: center; align-items: center">
          <v-icon @click="show_sidebar = !show_sidebar" style="cursor: pointer" large v-if="$vuetify.breakpoint.smAndDown"> keyboard_arrow_left </v-icon>
        </div>
      </div>
    </div>
    <div v-else-if="!hide_sidebar">
      <div style="width: 30px; height: 100%; border-left: solid 1px; display: flex; flex-direction: center; align-items: center">
        <v-icon @click="show_sidebar = !show_sidebar" style="cursor: pointer" large v-if="$vuetify.breakpoint.smAndDown"> keyboard_arrow_right </v-icon>
      </div>
    </div>
    <div v-if="!$vuetify.breakpoint.smAndDown || !show_sidebar || hide_sidebar" class="home-detail-content">
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
export default {
  props: ['header_max_height', 'full_element', 'overflow_auto', 'opacity', 'hide_sidebar'],
  data: () => ({
    show_sidebar: true,
  }),
  watch: {
    '$route.name' : function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.show_sidebar = false;
      }
    }
  },
  methods: {
    getHeight() {
      return window.innerHeight
    }
  }
}
</script>
<style>
  .home-detail {
    height: calc(100% - 78px);
    margin-top: 48px;

    /* position: fixed; */
    width: 100%;
    /* height: 100%; */
    /* margin-left: -50vw;
    top: 50%;
    left: 50%; */
    display: flex;
    flex-direction: row;
    /* flex-direction: row; */
    background-color: #292929;
    z-index: 1;
    position: fixed;
    left: 0px;
    top: 0px;
    padding: 10px;
  }
  .home-detail-mobile {
    height: calc(100% - 48px);
    margin-top: 48px;

    /* position: fixed; */
    width: 100%;
    /* height: 100%; */
    /* margin-left: -50vw;
    top: 50%;
    left: 50%; */
    display: flex;
    flex-direction: row;
    /* flex-direction: row; */
    background-color: #292929;
    z-index: 1;
    position: fixed;
    left: 0px;
    top: 0px;
    padding: 10px;
  }
  .home-detail-content {
    width: 100%;
    overflow: auto;
    height: 100%;
    /* padding: 10px 10px 10px 10px; */
  }
  .home-detail-sidebar {
    min-width: 400px;
    max-width: 400px;
    border-color: white;
  }
  .home-detail-sidebar-header {
    overflow: hidden;
    height: 200px;
    background-color: #202020;
    border-radius: 50px;
    padding: 20px;
    font-size: 25px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    /* text-align: center; */
    /* justify-content: center; */
  }
  .home-detail-sidebar-navigation {
    display: flex;
    flex-direction: row;
    /* margin-right: 20px; */
    height: 100%;
    /* border-right: solid 1px; */
    /* padding: 10px; */
  }
</style>
